import { AxiosResponse, Method } from 'axios';

import api from './apiUtil';

const makeApiCall = async <T>(
  url: string,
  method: Method | 'logIn'= 'get',
  data?: any
): Promise<T> => {
  const token = localStorage.getItem('accessToken');
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  let response: AxiosResponse<T>;

  switch (method) {
    case 'get':
      response = await api.get<T>(url, config);
      break;
    case 'put':
      response = await api.put<T>(url, data, config);
      break;
    case 'post':
      response = await api.post<T>(url, data, config);
      break;
    case 'logIn':
      response = await api.post<T>(url, data);
      break;
    case 'delete':
      response = await api.delete<T>(url, config);
      break;
    default:
      throw new Error('Invalid HTTP method');
  }

  return response.data;
};

export default makeApiCall;
